import i18n from "i18next";
import { toast } from "react-toastify";

export const handleFilingErrors = (errResponse, setValidationErrors) => {
  if (errResponse && errResponse.errors && Array.isArray(errResponse.errors)) {
    setValidationErrors(errResponse.errors);
    const message = i18n.t("m.filing.application.fail.rules");
    toast.error(message, { autoClose: 5000 });
  } else {
    toast.error(i18n.t("m.generic.error.service.fail") as string);
  }
};
